import { AnyAction } from '@reduxjs/toolkit'

import React, { Dispatch, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { postGameCodeRequest } from '../../../redux/actions/gameActions'
import Loading from '../../../components/Loading'

const QRCodeLoginValidate = () => {
  const { gameCode } = useParams()
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(
      postGameCodeRequest({ gameCode, navigate, redirect: 'instructions' }),
    )
  }, [])

  return <Loading />
}

export default QRCodeLoginValidate
